import React from 'react'
import { FlexRow, Icon, Text, Anchor } from 'elements'
import Banner from './Banner'

export default function ReportsHelpBanner({ onClose, ...props }) {
  return (
    <Banner onClose={onClose} {...props}>
      <FlexRow alignItems="center" mr="large">
        <Icon name="info-circle" size="medium" mr="xlarge" />
        <Text color="inherit" fontWeight="bold">
          Need help running a report?
        </Text>
      </FlexRow>
      <FlexRow alignItems="center">
        <Anchor
          fontSize="small"
          fontWeight="bold"
          color="inherit"
          as="a"
          href="https://www.scrutinize.io/howitworks"
          target="_blank"
        >
          View in FAQ&nbsp;&nbsp;→
        </Anchor>
      </FlexRow>
    </Banner>
  )
}
